<template>
  <div class="entry-overview flex overflow-hidden bg-white shadow sm:rounded-lg">
    <!-- Client entry detail -->
    <div class="entry-detail w-full">
      <article>
        <!-- Profile header -->
        <div>
          <div class="px-4 sm:px-6 lg:px-8">
            <div class="sm:flex sm:items-end sm:space-x-5">
              <div class="mt-2 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
                <div class="mt-6 min-w-0 flex-1 2xl:block">
                  <h1 class="truncate text-2xl font-bold text-font-darkest">
                    {{ client.name }}
                  </h1>
                </div>
                <div class="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
                  <button
                    type="button"
                    class="inline-flex justify-center rounded-md border border-font-lightest bg-white px-4 py-2 text-sm
                      font-medium text-font-dark shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    @click="showCreateForm = true">
                    <!-- Heroicon name: solid/folder-add -->
                    <svg
                      class="-ml-1 mr-2 size-5 text-font-light"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true">
                      <path
                        clip-rule="evenodd"
                        d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 00-2 0v1H8a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1V9z"
                        fill-rule="evenodd" />
                    </svg>
                    <span>New project</span>
                  </button>
                  <button
                    type="button"
                    class="inline-flex cursor-pointer justify-center rounded-md border border-font-lightest bg-white px-4 py-2 text-sm
                      font-medium text-font-dark shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    @click="showActivityForm = true;">
                    <DocumentTextIcon
                      class="-ml-1 mr-2 size-5 text-font-light"
                      aria-hidden="true" />
                    <span>Log an activity or a note</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="mt-2">
          <div class="border-b border-gray-200">
            <div class="flex justify-center px-4 sm:px-6 lg:px-8">
              <nav
                class="-mb-px flex space-x-8"
                aria-label="Tabs">
                <!-- Current: "border-primary text-indigo-600", Default: "border-transparent text-gray-500 hover:text-font-dark hover:border-font-lightest" -->
                <tab-link
                  :href="route('clients.show', {client: client})"
                  :active="route().current('clients.show')">
                  Overview
                </tab-link>
                <tab-link
                  :href="route('clients.projects', {client: client})"
                  :active="route().current('clients.projects')">
                  Projects
                </tab-link>
                <tab-link
                  :href="route('clients.activities', {client: client})"
                  :active="route().current('clients.activities')">
                  Activities
                </tab-link>
                <tab-link
                  :href="route('clients.details', {client: client})"
                  :active="route().current('clients.details')">
                  Contacts
                </tab-link>
              </nav>
            </div>
          </div>
        </div>

        <slot />
      </article>
    </div>

    <SimpleModalSmall
      :show="showActivityForm">
      <AddActivityForm
        :client="client"
        @close="showActivityForm = false" />
    </SimpleModalSmall>

    <Modal
      :show="showCreateForm"
      max-width="md"
      :closeable="true"
      @close="showCreateForm = false">
      <CreateProjectForm
        :client="client"
        @close="showCreateForm = false" />
    </Modal>
  </div>
</template>

<script>

import {
  DocumentTextIcon,
} from '@heroicons/vue/24/solid';
import SimpleModalSmall from '@/Components/Modals/SimpleModalSmall.vue';
import CreateProjectForm from '@/Components/CreateProjectForm.vue';
import Modal from '../../Jetstream/Modal.vue';
import AddActivityForm from '../../ComponentsDeprecated/AddActivityForm.vue';
import TabLink from '../../ComponentsDeprecated/TabLink.vue';

export default {
  components: {
    CreateProjectForm,
    SimpleModalSmall,
    TabLink,
    Modal,
    AddActivityForm,
    DocumentTextIcon,
  },

  props: {
    client: Object,
  },

  data() {
    return {
      showActivityForm: false,
      showCreateForm: false,
      activity: 'call',
    };
  },

  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
